import { Component,OnInit,OnDestroy,AfterViewInit,Input,Output,EventEmitter } from '@angular/core';
import { NgbModal,NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { takeWhile } from "rxjs/operators";

import {
    FvmsCommonService
    ,FvmsApiAuthService
    ,FvmsExcelService
    ,FvmsApiDtgGeoFenceService
    ,FvmsApiDtgTeamService
} from "src/app/shared/service";
import {
    PagingInfo
    ,DtgActionType
    ,DtgListType
} from "src/app/shared/vo";
import {
    GeofenceConfFormComponent
} from "src/app/dtg/manage/geofence/conf/form/geofence.conf.form.component";
import {
    DtgManageCarSearchComponent
} from "src/app/dtg/manage/car/search/dtg.manage.car.search.component";
import {
    ReportGeofenceHisPositionComponent
} from "src/app/dtg/report/geofence/his/position/report.geofence.his.position.component";

@Component({
    selector: "report-geofence-his-list"
    ,templateUrl: './report.geofence.his.list.component.html'
    ,providers: []
})
export class ReportGeofenceHisListComponent implements OnInit,OnDestroy,AfterViewInit {
    isContinue:boolean = true;
    companyInfo:any;
    currentUserInfo:any;
    pagingInfo:PagingInfo = new PagingInfo();
    dateTimeInfo:any;
    listGeofence:any[];
    listTeam:any[];
    listCarType:any[];
    dtgUnitId:string;
    dtgCarNo:string;
    runCnt:number = 1;
    shapeType:string = "";
    actType:string = "";
    searchValue:string;
    @Input() listType:DtgListType = DtgListType.list;
    @Output() geofenceInfo = new EventEmitter();
    DtgActionType = DtgActionType;
    DtgListType = DtgListType;
    userGroupId:number;
    dtgTeamId:string = "";
    dtgCarType:string = "0";
    useYn:string = "";

    constructor(
        private modalService: NgbModal
        ,private fvmsCommonService:FvmsCommonService
        ,private fvmsApiAuthService:FvmsApiAuthService
        ,private fvmsExcelService:FvmsExcelService
        ,private fvmsApiDtgGeoFenceService:FvmsApiDtgGeoFenceService
        ,private fvmsApiDtgTeamService:FvmsApiDtgTeamService
    ) {
        this.companyInfo = this.fvmsCommonService.getCompanyInfo();
        this.currentUserInfo = this.fvmsApiAuthService.getLoginUserInfo();
        this.userGroupId = parseInt(this.currentUserInfo.userGroupId);
        if(this.userGroupId > 100){
            this.dtgTeamId = this.currentUserInfo.teamId;
        }
        this.pagingInfo.pageSize = 15;
        this.dateTimeInfo = this.fvmsCommonService.getDateInfo();

        this.fvmsCommonService.subscribeCompanyInfo()
            .pipe(takeWhile(() => this.isContinue))
            .subscribe(companyInfo => {
                this.companyInfo = companyInfo;
                this.pagingInfo.curPage = 1;
                this.clickSearch();
            });

        this.fvmsCommonService.subscribeDateInfo()
            .pipe(takeWhile(() => this.isContinue))
            .subscribe(dateTimeInfo => {
                this.dateTimeInfo = dateTimeInfo;
                // this.dateInfo = dateInfo;
                // let dateFrom = new Date(this.dateInfo.fromDate.year,this.dateInfo.fromDate.month,this.dateInfo.fromDate.day);
                // let dateTo = new Date(this.dateInfo.toDate.year,this.dateInfo.toDate.month,this.dateInfo.toDate.day);
                // let dateDiff = this.filterDateDiff.transform(dateFrom,dateTo,"day");
                // this.dayDiff = dateDiff + 1;
                this.clickSearch();
            });
     }

    ngOnInit() {
        // this.reloadListItem();
        // this.reloadListItemTeam();
    }

    ngOnDestroy() {
        this.isContinue = false;
    }
    
    ngAfterViewInit() {
        
    }

    reloadListItem(){
        let searchInfo = {
            companyId : this.companyInfo?.companyId || 0
            ,dtgTeamId:this.currentUserInfo?.teamId || ""
            ,dtgUnitId : this.dtgUnitId
            ,runCnt : this.runCnt
            ,shapeType : this.shapeType
            ,actType : this.actType
            ,searchDateFrom:this.fvmsCommonService.getDateFromIsoReserve()
            ,searchDateTo:this.fvmsCommonService.getDateToIsoReserve()
            ,searchValue : this.searchValue
        };
        this.fvmsApiDtgGeoFenceService.listGeoFenceHis(searchInfo,this.pagingInfo)
            .pipe(takeWhile(() => this.isContinue))
            .subscribe(apiResponse => {
                if(apiResponse.resultStatus === "ok"){
                    this.listGeofence = apiResponse.resultValue;
                    this.pagingInfo = apiResponse.pagingInfo;
                }
            });
    }

    // 셀렉트박스 그룹목록
    reloadListItemTeam(){
        let searchInfo = {
            companyId : this.companyInfo?.companyId || 0
            ,dtgTeamId : this.currentUserInfo.teamId
            ,searchValue : null
        };
        let pagingInfoTeam = {
            "curPage":1
            ,"pageSize":1000
        };
        this.fvmsApiDtgTeamService.getListTeam(searchInfo,pagingInfoTeam)
            .pipe(takeWhile(() => this.isContinue))
            .subscribe(apiResponse => {
                if(apiResponse.resultStatus === "ok"){
                    this.listTeam = apiResponse.resultValue;
                }
            });
    }

    callbackClickPageNumber(pageNo: number) {
        this.pagingInfo.curPage=pageNo;
        this.clickSearch();
    }

    callbackChangeCountRowPerPage(pageSize:number){
        this.pagingInfo.pageSize = pageSize;
        this.callbackClickPageNumber(1);
    }

    clickSelectGeofence(geofenceInfo:any){
        this.geofenceInfo.emit(geofenceInfo);
    }

    //검색어 입력란에 엔터키 누르면 실행
    keyupEnterSearchValue(e){
        this.clickSearch();
    }

    clickSearch(){
        this.reloadListItem();
    }

    changeTeamInfo(event){
        this.clickSearch();
    }

    changeRunCnt(event){
        this.clickSearch();
    }

    changeShapeType(event){
        this.clickSearch();
    }

    changeActType(event){
        this.clickSearch();
    }

    clickOpenModalGeofenceInfo(dtgActionType:DtgActionType,geofenceInfo:any){
        let modalRef = this.modalService.open(
            GeofenceConfFormComponent
            ,{
                centered:true
                ,size: "xl"
                ,backdrop:"static"
                //windowClass: "dark-modal"
                ,scrollable: true
            }
        );
        modalRef.componentInstance.dtgActionType = dtgActionType;
        modalRef.componentInstance.companyId = geofenceInfo?.companyId || this.companyInfo.companyId;
        modalRef.componentInstance.teamId = geofenceInfo?.dtgTeamId;
        modalRef.componentInstance.geoFenceId = geofenceInfo?.geoFenceId;

        modalRef.result.then((resultModal) => {
            switch(dtgActionType){
                case DtgActionType.create:
                case DtgActionType.update:
                case DtgActionType.delete:
                    if(resultModal.result === "ok"){
                        this.clickSearch();
                    }
                    break;
                default:
                    break;
            }
        });
    }

    clickOpenModalGeofenceCarList(dtgActionType:DtgActionType){
        let modalRef = this.modalService.open(
            DtgManageCarSearchComponent
            ,{
                centered:true
                ,size: "xl"
                ,backdrop:"static"
                //windowClass: "dark-modal"
                ,scrollable: true
            }
        );

        modalRef.result.then((resultModal) => {
            if(resultModal.result === "ok"){
                this.dtgUnitId = resultModal.carInfo.dtgUnitId;
                this.dtgCarNo = resultModal.carInfo.dtgCarNo;
                this.clickSearch();
            }
        });
    }

    clickOpenModalGeofenceHisPosition(dtgActionType:DtgActionType,geofenceInfo:any){
        let modalRef = this.modalService.open(
            ReportGeofenceHisPositionComponent
            ,{
                centered:true
                ,size: "lg"
                ,backdrop:"static"
                //windowClass: "dark-modal"
                ,scrollable: true
            }
        );
        modalRef.componentInstance.dtgActionType = dtgActionType;
        modalRef.componentInstance.companyId = geofenceInfo?.companyId || this.companyInfo.companyId;
        modalRef.componentInstance.teamId = geofenceInfo?.dtgTeamId;
        modalRef.componentInstance.geoFenceId = geofenceInfo?.geoFenceId;
        modalRef.componentInstance.dtgUnitId = geofenceInfo?.dtgUnitId;
        modalRef.componentInstance.dtgRegDt = geofenceInfo?.dtgRegDt;

        modalRef.result.then((resultModal) => {
            switch(dtgActionType){
                case DtgActionType.create:
                case DtgActionType.update:
                case DtgActionType.delete:
                    if(resultModal.result === "ok"){
                        // this.clickSearch();
                    }
                    break;
                default:
                    break;
            }
        });
    }

    exportExcel(){

    }
}